module.exports = __webpack_public_path__ + "img/red-packet-rain.53dc453f.png";